<app-button icon="filter_list"
            [disabled]="disabled"
            (onClick)="filters.open()"
            [matBadge]="filtersLength">
  {{ 'dashboard_report.dimension_filter' | translate }}</app-button>
<app-dimension-filters #filters
                       class="display-block"
                       [values]="this.form.get('filters').value"
                       (onApply)="onFilters($event)"></app-dimension-filters>

